// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"47":"3dbadb70","230":"6f67f96c","453":"e8950b82"}[chunkId] + ".chunk.js";
};